module.exports = __webpack_public_path__ + "static/media/DEU.0a88386d.svg";